import { render, staticRenderFns } from "./FeesReport.vue?vue&type=template&id=1f0065b2&scoped=true&"
import script from "./FeesReport.vue?vue&type=script&lang=js&"
export * from "./FeesReport.vue?vue&type=script&lang=js&"
import style0 from "./FeesReport.vue?vue&type=style&index=0&id=1f0065b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0065b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f0065b2')) {
      api.createRecord('1f0065b2', component.options)
    } else {
      api.reload('1f0065b2', component.options)
    }
    module.hot.accept("./FeesReport.vue?vue&type=template&id=1f0065b2&scoped=true&", function () {
      api.rerender('1f0065b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/accounting/FeesReport.vue"
export default component.exports